import axios from 'axios';
import store from '@/store';
import { getToken } from '@/utils/TokenHelper';
import userValidate from "@/api/requestValidate";
import router from '@/router';
import { notification } from 'ant-design-vue';
// create an axios instance
const service = axios.create({
    baseURL: window.BASE_CONFIG.VUE_APP_BASE_API, // api的base_url
    timeout: 1000 * 60, // request timeout
    withCredentials: false, //使前台能够保存cookie
});

// request interceptor
service.interceptors.request.use(
    async (config) => {
        let res =null;
        if(!(config.url.indexOf('api/v1/login/login')>-1||config.url.indexOf('api/v1/user/getUserInfo')>-1)) {
            sessionStorage.setItem('lastClickTime',(new Date()).getTime());
            try {
                res = await userValidate({
                    url: window.BASE_CONFIG.USER_API + 'api/v1/user/getUserInfo',
                    method: 'get',
                });
            } catch (e) {
                Promise.reject('token已失效');
                console.log('token已失效')
                store.commit('CLEAR_TOKEN');
                router.push({path:'/login'})
                notification.warn({
                    message: '登录失效',
                    description: '当前用户登录信息已失效！',
                });
            }
        }
        console.log('xxxxxxxxxxxxxxxxxxxxxxxxxxxxx',res)
        if (store.getters.token) {
            config.headers["token"] = getToken(); // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
        }
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);

// respone interceptor
service.interceptors.response.use(
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    (res) => {
        if (res.status === 200 && [200, null, undefined].includes(res.data.code)) {
            return res;
        }
        if (res.data.succ) {
            //如果后台返回的json显示成功，pass
            return res;
        } else {
            //其它错误弹出错误信息
            // Notification.error({ message: res.data.msg, title: "失败" });
            if (res.data.code == 401) {
                //处理登录相关的错误
                store.dispatch("LogOut").then(() => {
                    location.reload(); // 为了重新实例化vue-router对象 避免bug
                });
            } else {
                //其它错误弹出错误信息
                console.warn({ message: res.data.msg, type: "error", duration: 5000 });
                return res;
            }
            return Promise.reject(res);
        }
    },

    /**
     * 请求发生错误，一般都是服务器抛异常了
     */
    (err) => {
        if (axios.isCancel(err)) {
            console.log('因路由跳转请求已取消', err);
            return new Promise(() => {});
        } else {
            console.error('request err: %o', err); // for debug
            // Message({ message: error.message, type: 'error', duration: 5000 });
            return Promise.reject(err);
        }
    }
);

export default service;
